import * as Cesium from 'cesium'

export class Rotation {
  constructor (viewer, option = { p: 0.02 }) {
    this.viewer = viewer.getViewer()
    // current lon lat height
    const ellipsoid=this.viewer.scene.globe.ellipsoid;
    const cartesian3 = this.viewer.camera.position;
    const cartographic = ellipsoid.cartesianToCartographic(cartesian3);
    this.lat = Cesium.Math.toDegrees(cartographic.latitude); // 当前经度
    this.lon = Cesium.Math.toDegrees(cartographic.longitude); // 当前纬度
    this.height = cartographic.height
    // console.log(this.lon, this.lat, this.height) 
    this.timer = null
    this.i = this.lon // 起始经度设置为当前经度
    this.p = option.p // 每帧移动的经度角度
    this.fps = 20 // 每秒帧数
  }

  icrf () {
    if (!this.viewer || this.viewer.scene.mode !== Cesium.SceneMode.SCENE3D) {
      return
    }
    this.i = this.i <= -180 ? 180 : this.i - this.p;
    const x = this.i
    const y = this.lat
    const h = this.height
    var center = Cesium.Cartesian3.fromDegrees(x, y, h);
    this.viewer.camera.flyTo({
      destination: center,
      duration: 1/this.fps
    });
  }

  start () {
    this.timer = setInterval(() => {
      this.icrf()
    }, 1000 / this.fps)
  }

  stop () {
    if (!this.viewer) {
      return
    }
    clearInterval(this.timer)
    this.timer = null
  }
}
